import PropTypes from 'prop-types';
import { useState } from 'react';
import { useScreenSizeContext } from '@/components/ScreenSize.context';
import { useAppSelector } from '@/redux';

import VideoESpot from '@/components/layout/espots/VideoESpot';
import Icon from '@/components/common/iconedLinks/Icon';
import { URLS } from '@/constants/urls';

const LazyVideoPlayer = ({ img, video, isSmall = false, customClassName }) => {
  const breakpoint = useScreenSizeContext().mappedBreakpoint;
  const locale = useAppSelector(({ root }) => root.storeConf.locale);

  const [displayVideo, setDisplayVideo] = useState(false);

  const imageStyle = img ? {
    background: `center no-repeat url(${img})`,
    backgroundSize: isSmall ? 'contain' : 'auto'
  } : {};

  const videoClassName = [
    customClassName?.['video'],
  ].filter(Boolean);

  return (
    <div className="lazy-video-player" data-test-id="lazy-video-player">
      {displayVideo ? (
        <div className={`lazy-video-player-video ${videoClassName}`} data-test-id="lazy-video-player-video">
          <VideoESpot data={video} lang={locale} isSmall={isSmall} withAutoplay />
        </div>
      ) : (
        <div
          data-test-id="lazy-video-player-image"
          className={`lazy-video-player-image lazy-video-player-image-${breakpoint} ${videoClassName}`}
          onClick={() => setDisplayVideo(true)}
          style={imageStyle}
        >
          <Icon src={URLS.ICON_YOUTUBE_WHITE} alt="youtube" className="lazy-video-player-icon" />
        </div>
      )}
    </div>
  );
};

LazyVideoPlayer.propTypes = {
  img: PropTypes.string,
  video: PropTypes.shape({
    idYoutube: PropTypes.string.isRequired
  }).isRequired,
  locale: PropTypes.string.isRequired,
  isSmall: PropTypes.bool,
  customClassName: PropTypes.oneOfType([PropTypes.string, PropTypes.object])
};

export default LazyVideoPlayer;
